import { Size, Token, } from "../../../core";
export class FlagToken extends Token {
    constructor(id, position, color) {
        super(id, position, FlagToken.size);
        this.color = color;
    }
    static isReadonlyInstance(token) {
        return token instanceof FlagToken;
    }
}
FlagToken.size = new Size(1, 1);
export function getFlagTokenFactory(color) {
    return (id, position) => {
        return new FlagToken(id, position, color);
    };
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZmxhZy10b2tlbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9zcG9ydHMvY29tbW9uL2RyaWxsL2ZsYWctdG9rZW4udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUlMLElBQUksRUFDSixLQUFLLEdBRU4sTUFBTSxlQUFlLENBQUM7QUFFdkIsTUFBTSxPQUFPLFNBQVUsU0FBUSxLQUFLO0lBQ2xDLFlBQVksRUFBVSxFQUFFLFFBQWtCLEVBQUUsS0FBWTtRQUN0RCxLQUFLLENBQUMsRUFBRSxFQUFFLFFBQVEsRUFBRSxTQUFTLENBQUMsSUFBSSxDQUFDLENBQUM7UUFDcEMsSUFBSSxDQUFDLEtBQUssR0FBRyxLQUFLLENBQUM7SUFDckIsQ0FBQztJQU1ELE1BQU0sQ0FBQyxrQkFBa0IsQ0FBQyxLQUFvQjtRQUM1QyxPQUFPLEtBQUssWUFBWSxTQUFTLENBQUM7SUFDcEMsQ0FBQzs7QUFKZSxjQUFJLEdBQUcsSUFBSSxJQUFJLENBQUMsQ0FBQyxFQUFFLENBQUMsQ0FBQyxDQUFDO0FBV3hDLE1BQU0sVUFBVSxtQkFBbUIsQ0FBQyxLQUFZO0lBQzlDLE9BQU8sQ0FBQyxFQUFVLEVBQUUsUUFBa0IsRUFBRSxFQUFFO1FBQ3hDLE9BQU8sSUFBSSxTQUFTLENBQUMsRUFBRSxFQUFFLFFBQVEsRUFBRSxLQUFLLENBQUMsQ0FBQztJQUM1QyxDQUFDLENBQUM7QUFDSixDQUFDIn0=